// extracted by mini-css-extract-plugin
module.exports = {"filterSection":"FiltersSidebar_filterSection__3UCQ5"};